import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../api/api';

export const branchApi = createApi({
  reducerPath: 'branchApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Branch'],
  endpoints: (builder) => ({
    getBranches: builder.query({
      query: (page = 1) => ({
        url: 'api/web/v1/site/branch',
        method: 'GET',
        params: { page },
        tokenType: 'admin',
      }),
      providesTags: ['Branch'],
    }),
    addBranch: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/add-branch',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['Branch'],
    }),
    updateBranch: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/update-branch',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['Branch'],
    }),
    deleteBranch: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/delete-branch',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['Branch'],
    }),
  }),
});

export const {
  useGetBranchesQuery,
  useAddBranchMutation,
  useUpdateBranchMutation,
  useDeleteBranchMutation,
} = branchApi;
